// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiUlr: 'https://api.mylog.dev/api/v1',
    oauthTokenUrl: 'https://api.mylog.dev/oauth/token',
    domain: 'app.mylog.dev',
    apiDomain: 'api.mylog.dev',
};

export const client = {
    client_secret: 'Ruxv2sykyNA8TeOI5KVkpLQr7McjdcMELjACJO7M',
    client_id: 2,
    grant_type: 'password'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
